// Utils
import getOverflowingEdges from './getOverflowingEdges';

// Constants
import { RECT_EDGES } from '../../../../../common/maths/geometry/rect/rectConstants';

// FIXME Use rect.js
/**
 * Returns all edges that the targetRect is completely overflowing.
 * E.g. Both of the target rect's sides in a dimension must be overflowing for that side to be
 * considered to be completely overflowing.
 */
export default ({ targetPoint, targetRect, layerRect }) => {
    if (targetPoint) return getOverflowingEdges({ targetPoint, layerRect });

    const overflowEdges = [];

    if (targetRect.right <= layerRect.left) overflowEdges.push(RECT_EDGES.left);
    if (targetRect.left >= layerRect.right) overflowEdges.push(RECT_EDGES.right);
    if (targetRect.bottom <= layerRect.top) overflowEdges.push(RECT_EDGES.top);
    if (targetRect.top >= layerRect.bottom) overflowEdges.push(RECT_EDGES.bottom);

    return overflowEdges;
};
